// Shared between the API and the UI so the counter a user sees matches the
// rule the server enforces. Unbounded writes would otherwise be the cheapest
// way to fill a free-tier cluster.
export const MAX_POST_LENGTH = 2000;
export const MAX_COMMENT_LENGTH = 500;
